import React, { Component } from 'react';
import './header.css';

export default class Header extends Component {
  render() {
    return (
      <div className="header">
        <div className="header-logo">
          <img
            src="/images/logo.png"
            alt="Chootu"
            onClick={() => {
              this.props.setRenderedPage('dashboards');
            }}
          />
        </div>
        <div className="header-actions" />
      </div>
    );
  }
}
